import React from 'react';
import Icon from '../../../components/AppIcon';

const CertificationsSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-text-primary mb-4">
            Zertifizierungen & Auszeichnungen
          </h2>
          <p className="text-lg text-text-secondary max-w-3xl mx-auto">
            Unsere professionellen Qualifikationen und Anerkennungen belegen höchste Standards in der Rechtsberatung.
          </p>
        </div>

        {/* Compliance Statement */}
        <div className="bg-gradient-to-r from-primary to-accent rounded-xl p-8 text-white">
          <div className="flex items-center space-x-4 mb-4">
            <Icon name="Shield" size={32} />
            <h3 className="text-2xl font-semibold">
              Rechtliche Compliance & Transparenz
            </h3>
          </div>
          <p className="text-lg opacity-90 mb-4">
            Als ADVOCALL RECHTSANWALTSGESELLSCHAFT MBH unterliegen wir den höchsten
            professionellen Standards der deutschen Anwaltschaft.
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm opacity-90">
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} />
              <span>Berufsrechtliche Vorschriften (BRAO)</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} />
              <span>Fachanwaltschaftsordnung (FAO)</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} />
              <span>EU-Datenschutzgrundverordnung (DSGVO)</span>
            </div>
            <div className="flex items-center space-x-2">
              <Icon name="Check" size={16} />
              <span>Bundesdatenschutzgesetz (BDSG)</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CertificationsSection;